// RNG có seed cho mọi hệ thống sim (TECH_BASELINE §4.1, BALANCE §0).
// mulberry32 + băm FNV-1a; mỗi hệ tách luồng riêng bằng nhãn để một lần roll ở hệ A
// không làm lệch hệ B.

/** Băm FNV-1a 32 bit của một chuỗi. */
export function fnv1a(s: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return h >>> 0;
}

/** Trộn seed với các nhãn / mốc thành seed con tất định: hash(seed, 'idle', blockIndex). */
export function deriveSeed(seed: number, ...parts: (string | number)[]): number {
  return fnv1a(`${seed >>> 0}|${parts.join('|')}`);
}

export interface Rng {
  /** Số thực trong [0, 1). */
  next(): number;
  /** Số nguyên trong [0, n). */
  int(n: number): number;
  /** Luồng con tất định theo nhãn. */
  fork(label: string): Rng;
  /** Seed khởi tạo của luồng (để ghi vào báo cáo / replay). */
  readonly seed: number;
}

export function createRng(seed: number): Rng {
  let a = seed >>> 0;
  const next = (): number => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
  return {
    seed: seed >>> 0,
    next,
    int: (n) => Math.floor(next() * n),
    fork: (label) => createRng(deriveSeed(seed, label)),
  };
}
